import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ModuleStructure } from 'src/app/models/module-structure';
import * as Handlebars from 'handlebars';
import { LayoutService } from '../layout.service';

import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { Board } from './models/board.model';
import { Column } from './models/column.model';
import {
  SectionTableFilter,
  SectionTableFilterTypes,
} from 'src/app/models/section-table-filter';
import { ModuleInformation } from 'src/app/models/module-information';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-records-list-container',
  templateUrl: './records-list-container.component.html',
  styleUrls: ['./records-list-container.component.less'],
})
export class RecordsListContainerComponent implements OnInit {
  @Input() selectedId = '';
  @Input() isLoading = true;
  @Input() isKanban = false;
  moduleIdVar = 0;
  moduleInformation: ModuleInformation;
  @Input() set moduleId(value: number) {
    if (this.moduleIdVar !== value) {
      this.moduleIdVar = value;
      this.initializeList();
    }
  }

  get moduleId() {
    return this.moduleIdVar;
  }

  //filters: { [key: string]: SectionTableFilter };
  selectedRecords: any[];
  cardsInfo: any[];

  screenSize: string;
  board: Board = new Board('Board', []);
  switchValue = false;
  kanColn: any;
  pageSizeArray: number[] = [];
  moduleStructure: ModuleStructure;
  fields: any[];
  sortedByDir: string;
  sortedByField: number;
  sortedByName: string;
  enableKanban: boolean;
  kanbanBoardsQueryId: number;
  kanbanPropertyName: string;
  public screenWidth: any;
  public screenHeight: any;
  filtersValue: { [key: string]: SectionTableFilter };
  @Input() set filters(value: { [key: string]: SectionTableFilter }) {
    this.filtersValue = value;
  }

  @Output() selectionChanged = new EventEmitter<string[]>();

  constructor(
    private layoutService: LayoutService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // this.activatedRoute.params.subscribe((params) => {
    //   if (this.selectedId !== params.selectedId) {
    //     this.isLoading = true;
    //     this.selectedId = params.selectedId;
    //   }
    // });

    this.screenSize = this.layoutService.screenSize;
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    this.initializeList();
    this.activatedRoute.params.subscribe((params) => {
      if (params === undefined || !this.isKanban) {
        return;
      }

      if (params.selectedId !== undefined && params.selectedId !== null) {
        if (
          this.selectedRecords !== undefined
          //  ||
          // this.selectedRecords.indexOf(params.selectedId) === -1
        ) {
          if (
            this.selectedRecords.length === 1 &&
            this.selectedRecords[0] === params.selectedId
          ) {
            return;
          } else {
            this.selectedRecords = [];
            this.selectedRecords.push(params.selectedId);
            this.selectionChanged.emit(this.selectedRecords);
          }
        }
      }
    });
  }

  initializeList() {
    this.layoutService
      .getModuleStructure(this.moduleId)
      .subscribe((m: ModuleStructure) => {
        this.moduleStructure = m;
        this.enableKanban = this.moduleStructure.module.AdditionalInformationParsed.EnableKanban;
        this.kanbanBoardsQueryId = this.moduleStructure.module.AdditionalInformationParsed.KanbanBoardsQueryId;
        this.kanbanPropertyName = this.moduleStructure.module.AdditionalInformationParsed.KanbanPropertyName;
        if (this.enableKanban && this.kanbanBoardsQueryId !== 0) {
          this.layoutService
            .executeQuery(this.kanbanBoardsQueryId, [])
            .subscribe((kanColns: any[]) => {
              this.filters = {};
              this.kanColn = kanColns;
              this.board.columns = this.kanColn;
              console.log('this.board', this.board);
            });
        }
        this.isLoading = false;
      });

    this.layoutService
      .moduleInformation(this.moduleId.toString())
      .subscribe((d: ModuleInformation) => {
        this.moduleInformation = d;
        this.board.name = this.moduleInformation.PluralName;
        this.moduleInformation.ModuleId = this.moduleId;
      });
  }

  getRecordHtml(record) {
    const template = Handlebars.compile(
      this.moduleStructure.module.AdditionalInformationParsed.ListTemplate
    );
    const html = template(record);
    return html;
  }

  drop(event: CdkDragDrop<object[]>) {
    console.log(event);
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      console.log(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      console.log(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  isNumber(val): boolean {
    return typeof val === 'number';
  }
}
